import '../../CommonStyles.scss';
import './KpiCard.scss';
import { ReactNode } from 'react';
import SourceBadge from '../SourceBadge/SourceBadge';
import Paper from '@trackman/web-shared-components/components/Paper/Paper';
import { DataSource } from 'types/admin/analytics';

interface KpiCardProps {
  label: string;
  sources: DataSource[];
  value: number | string;
  customClasses?: string;
  children?: ReactNode;
}

export const KpiCard = ({ label, sources, value, customClasses, children }: KpiCardProps) => (
  <Paper className={`kpi-card ${customClasses || ''}`}>
    <div className='kpi-card-header'>
      <span className='kpi-label'>{label}</span>
      <div>
        {sources.map((source) => (
          <SourceBadge key={source} source={source} />
        ))}
      </div>
    
    </div>
    <div className='kpi-value'>{value.toLocaleString()}</div>
    {children && <div className='kpi-meta'>{children}</div>}
  </Paper>
);

export default KpiCard;
